import { PostType } from '@/graphql/generated/types.generated';
import { PostTypeNumber } from './post-type-mapper';

export const PostTypeNumberNameKey: Record<PostTypeNumber, string> = {
    [PostTypeNumber.LINK]: 'str.link',
    [PostTypeNumber.MEDIA]: 'str.media',
    [PostTypeNumber.REEL]: 'str.reel',
    [PostTypeNumber.STATUS]: 'str.status',
    [PostTypeNumber.STORY]: 'str.story',
};

export const PostTypeNameKey: Record<PostType, string> = {
    [PostType.Link]: 'str.link',
    [PostType.Media]: 'str.media',
    [PostType.Reel]: 'str.reel',
    [PostType.Status]: 'str.status',
    [PostType.Story]: 'str.story',
};

export default PostTypeNameKey;
